<div class="page-controls mb10" *ngIf="contentData" >
    <a (click)='getNewsAndMedia(contentData)' class="utils.getDocumentIcon('link')">
        <cbic-static-text class="btn-link" [textEn]="'Back'" [html]="false"></cbic-static-text></a>
</div>
 
<!-- <div class="form-control" *ngIf="parentData===16410||parentData===16411">

    <input type="text" class="form-control" id="search" placeholder="Search" [(ngModel)]="searchText"
        autocomplete="off">

</div> -->

<!-- <div class="form-control" *ngIf="parentData===16410||parentData===16411">

    <input type="text" class="form-control" id="search" placeholder="Search" [(ngModel)]="searchText" autocomplete="off"
        (pageChange)="onTableDataChange($event)">

</div> -->

<div class="page-controls mb10" *ngIf="totalRecords > 0">
    <select (change)="ontableSizeChange($event)" class="form-select-sm show_entries float-start"
        *ngIf="(searchText.length === 0)" style="margin-right:15px">
        <option *ngFor="let size of tableSizes" [selected]="size == pageSize">
            {{size}}
        </option>
    </select>
    <div class="col-4 float-start"
        *ngIf="parentData===16410||parentData===16411 ||parentData===30604||parentData===30607" style="height: 15px;
    margin-bottom: 15px;">

        <div class="col-5">
            <select id="search" [(ngModel)]="searchText" class="form-select">
                <option value="" disabled>Select Year</option>
                <option *ngFor="let year of years">{{ year }}
                </option>
            </select>

        </div>
        <!-- <input type="text" class="form-control" id="search" placeholder="Search" [(ngModel)]="searchText"
            autocomplete="off"> -->

    </div>



    <div class="float-end" *ngIf="(searchText.length === 0)">
        <pagination-controls id="{{pageControlsId}}" previousLabel="Prev" nextLabel="Next"
            (pageChange)="onTableDataChange($event)"></pagination-controls>

    </div>

</div>


<div class="float-start col-12" style="margin-top:15px;">
    <div *ngIf="getTableInfo() as tableContentInfo"
        class="table-responsive common-table custom-scroll-bar  horizontal-scroll common-table-height">
        
        <table *ngIf="(tableContentInfo!.body | filterYear:searchText).length > 0; else noResults || totalRecords > 0"
            class="table table-hover table-bordered table-striped shadow">
            
            <thead class="table-light ">
                <tr>
                    <th>S No</th>
                    <th *ngFor="let column of tableContentInfo!.headers" [style]="column.style">
                        <cbic-static-text [textEn]="column.title.En" [textHi]="column.title.Hi"></cbic-static-text>
                    </th>
                    <th><cbic-static-text [textEn]="downloadLabel.En" [textHi]="downloadLabel.Hi">
                        </cbic-static-text></th>
                </tr>
            </thead>
            <tbody class="customizeHeight custom-scroll-bar ">

                <tr
                    *ngFor="let row of tableContentInfo!.body | filterYear:searchText | paginate :{id: pageControlsId, itemsPerPage :pageSize,currentPage: currentPage, totalItems: totalRecords}; index as inx">
                    <td *ngIf="(searchText.length === 0)">{{currentPage! * pageSize! - pageSize! + inx + 1}}</td>
                    <td *ngIf="(searchText.length !== 0)">{{inx + 1}}</td>
                    <td *ngFor="let column of tableContentInfo!.headers ">
                        <cbic-static-text [trimContent]="true" [trimCharsLimit]='column.displayTextLimit'
                            [textEn]="row[column.dataKey!.En]" [textHi]="row[column.dataKey!.Hi]">
                        </cbic-static-text>
                    </td>
                    <td>
                        <!-- Code to open child content in fresh widow-->
                        <span
                            *ngIf="row.contentType.id===53 && ( row.childContentCount > 0  || !row.path.startsWith('/entities/'))"
                            (click)="getNewsAndMedia(row.id)" class="utils.getDocumentIcon('link')">
                            <i aria-hidden="true" class="dark external-link ng-star-inserted"></i>
                        </span>
                        <cbic-link *ngIf="row.contentType.id===53 && hasInfo(row) && row.childContentCount ==0"
                            [linkEn]="row.path" [linkHi]="row.path"
                            [iconClass]="utils.getDocumentIcon('link')"></cbic-link>
                        <cbic-link
                            *ngIf="row.contentType.id !=53 && (hasInfo(row) || row.childContentCount > 0 || !row.path.startsWith('/entities/')) 
                            ||row.contentType.id ==8 && row.parentId ==16413 ||row.contentType.id ==8 && row.parentId ==16414||row.contentType.id ==8 && row.parentId==16415 ||row.contentType.id ==8 && row.parentId==16430 || row.contentType.id ==8 && row.parentId==16416 && (hasInfo(row) || row.childContentCount > 0 || row.path.startsWith('/entities/cbic-content-mst/'))
                            ||row.contentType.id ==17 && row.parentId==16418 ||row.contentType.id ==17 && row.parentId==16417
                            ||row.contentType.id ==17 && row.parentId==16433 && (hasInfo(row) || row.childContentCount > 0 || row.path.startsWith('/entities/cbic-content-mst/'))"
                            [linkEn]="row.path" [linkHi]="row.path"
                            [iconClass]="utils.getDocumentIcon('link')"></cbic-link>
                        <!-- Code to open pop-up for child content -->
                        <!-- <span *ngIf="row.childContentCount > 0"
                        (click)="showMoreContent(row.id)">
                        <button  class="pop-link">
                            <i class="{{utils.getDocumentIcon('link')}}" aria-hidden="true"></i>
                        </button>
                    </span> -->
                        <span *ngFor="let doc of row.cbicDocMsts" (click)="viewFile(doc)" class="pop-link">
                            <cbic-static-text *ngIf="doc.docTitleEn === row.titleEn || doc.docTitleHi === row.titleHi"
                                [textEn]="" [textHi]=""></cbic-static-text>
                            <span *ngIf="doc.orderId > 1">|</span>
                            <cbic-static-text *ngIf="doc.docTitleEn !== row.titleEn || doc.docTitleHi !== row.titleHi"
                                [textEn]="doc.docTitleEn" [textHi]="doc.docTitleHi">
                            </cbic-static-text>
                            <i *ngIf="doc.docType" class="{{utils.getDocumentIcon(doc.docType.toLowerCase())}}"
                                aria-hidden="true"></i>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <ng-template #noResults>
            <p *ngIf="parentData===16410||parentData===16411 ||parentData===30604||parentData===30607">No results found
                for "{{searchText}}".</p>
        </ng-template>
    </div>
</div>